import { render, staticRenderFns } from "./PublicChangelog.vue?vue&type=template&id=3695a0c7&scoped=true&lang=pug&"
import script from "./PublicChangelog.vue?vue&type=script&lang=js&"
export * from "./PublicChangelog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3695a0c7",
  null
  
)

export default component.exports